var {combineReducers} = require('redux')
var {reducer: formReducer} = require('redux-form')

module.exports = combineReducers({
  form: formReducer
})


/** WEBPACK FOOTER **
 ** C:/repos/bbf116e8ea10ef38447b/reducers.js
 **/